import React, {useState} from 'react';
import {Badge} from "../../components/routing/Badge";
import {ButtonBase} from "@mui/material";
import classNames from "classnames";
import {IoMdArrowDropdown} from "react-icons/io";
import UserDropDown from "../../routing/UserDropDown";
import RegisterSubMenu from "../../components/RegisterSubMenu";
import SubMenu from "../../components/routing/SubMenu";
import {Nav} from "../../routing/nav/navs";
import {ClassNameMap} from "@mui/styles";
import {useNavigate} from "react-router";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import {IObservableVariable} from "../../components/constants/observable-constants";
import {styled} from "@mui/material/styles";

export type NavMenuItemType = {
  urlParams?: string,
  label: string,
  path: string,
  submenus?: Array<NavMenuItemType>,
  className?: string,
  highlighted?: boolean,
  modal?: boolean,
  badgeObservable?: IObservableVariable;
  exact?: boolean;
  logoType?: string;
  external?: boolean;
};

export type NavMenuItemProps = {
  activeMenuItem: string,
  activeSubmenu: string,
  buyerSpaceUsageRedesign: boolean,
  classes: ClassNameMap,
  index: number,
  isSticky?: boolean,
  logout: (event: React.MouseEvent) => void,
  menuItem: NavMenuItemType,
  navMenu: Array<Nav>,
  overrideFontColor?: boolean,
  setActiveMenuItem: (menuItem: NavMenuItemType, path?: string) => void
};

const LargeFontFocusedButton = styled(ButtonBase)(() => ({
  '&:focus-visible': {
    fontWeight: '900 !important',
  }
}));

const NavMenuSubmenuListItem: React.FC<NavMenuItemProps> = ({
  activeMenuItem,
  activeSubmenu,
  buyerSpaceUsageRedesign,
  classes,
  index,
  isSticky,
  logout,
  menuItem,
  navMenu,
  overrideFontColor,
  setActiveMenuItem,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [showRegisterDropdown, setShowRegisterDropdown] = useState<boolean>(false);
  const navigate = useNavigate();

  const isRegisterOption = menuItem.path === 'register';

  const className = overrideFontColor && !isSticky ?
    'ss-nav-menu-item ss-home-nav-menu-item' : 'ss-nav-menu-item' + (menuItem.badgeObservable ? " has-badge " : "");

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSubmenuClick = (path: string) => {
    handleClose();
    setActiveMenuItem(menuItem, path);
    navigate('/' + path);
  };

  const toggleButtonId = menuItem.label + "-menu-toggle-button";
  const subMenuId = menuItem.label + "-menu";
  const menuOpen = Boolean(anchorEl);

  return (
    <li key={index} className={className}>
      {
        menuItem.label === 'Account' ? <UserDropDown
          overrideFontColor={overrideFontColor && !isSticky}
          name={menuItem.label}
          menuItem={menuItem}
        /> :
        <LargeFontFocusedButton
          id={toggleButtonId}
          className={classNames(
            "ss-nav-submenu-toggle",
            (activeMenuItem === menuItem.path ? " active" : ""),
            menuItem?.className,
            {"ss-nav-menu-item-highlighted": menuItem?.highlighted},
            classes.navMenuItem,
            overrideFontColor && !isSticky ? classes.fontColor : "")
          }
          onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
            event.stopPropagation();
            event.preventDefault();
            if (menuItem.path === "register"){
              setActiveMenuItem(menuItem);
              setShowRegisterDropdown(!showRegisterDropdown);
            }
            setAnchorEl(event.currentTarget);
          }}
          aria-controls={menuOpen ? subMenuId : undefined}
          aria-haspopup={"menu"}
          aria-expanded={menuOpen}
        >
          {
            <Badge
              type="left"
              menuItem={menuItem}
            />
          }
          {menuItem.label}
          <IoMdArrowDropdown
            size={20}
            className={overrideFontColor && !isSticky ? classes.fontColor : classes.otherPageFontColor}
          />
        </LargeFontFocusedButton>
      }
      {
        isRegisterOption ?
          <ClickAwayListener onClickAway={() => {
            setShowRegisterDropdown(false)
          }}>
            <div>
              <RegisterSubMenu
                show={showRegisterDropdown}
                onClick={() => setShowRegisterDropdown(!showRegisterDropdown)}
              />
            </div>
          </ClickAwayListener>
          :
          <SubMenu
            id={subMenuId}
            anchorEl={anchorEl}
            show={menuOpen}
            onClose={handleClose}
            activeSubMenuItemPath={activeSubmenu}
            menuItem={menuItem}
            menuItemIndex={index}
            menuTotalItems={navMenu.length}
            onSubMenuItemClick={handleSubmenuClick}
            handleLogout={logout}
            buyerSpaceUsageRedesign={buyerSpaceUsageRedesign}
            MenuListProps={{
              "aria-labelledby": toggleButtonId,
            }}
          />
      }
    </li>
  );
};

export default NavMenuSubmenuListItem;
